<template lang="pug">
  div.input-field(
    ref="inputField"
    :key="question"
    :style="combineStyles"
    :class="combineStateClasses")
    slot(name="label" v-bind:label="label" v-if="label")
      label.input-field__label(:for="inputId") {{label}}
        span(v-if="required").input-field__label-tooltip  * <span>Обязательное поле</span>
    div.input-field-group.input-field__group
      slot(name="ico" v-bind:ico="ico" v-if="ico")
        div.input-field-group__ico
          img(:src="ico")
      slot(name="prepend" v-bind:prepend="prepend")
        div.input-field-group__prepend(:class="{'is-on-start': !ico}" v-if="prepend")
          template(v-if="typeof setPrepend === 'string'") {{setPrepend}}
          template(v-else)
            component(:is="setPrepend" @cb="changeHandler")
      input.input-field-group__field(
        :id="inputId"
        :type="fieldType"
        :name="name"
        :placeholder="placeholder"
        :disabled="isDisabled"
        v-model="inputVal"
        @paste="checkNumberInput"
        @change="changeHandler"
        @focus="stateHandler"
        @blur="stateHandler"
        @keypress="checkNumberInput"
      )
      slot(name="append" v-bind:append="append" v-if="append")
        div.input-field-group__append {{append}}
    div.input-field__error(v-if="hasError")
      | {{errorMessage}}
</template>

<script>
  // mixins
  import fieldProps from '@/mixins/fieldProps'
  import checkConditions from '@/mixins/questionConditions'
  import combineStyles from '@/mixins/combineStyles'

  const checkPhoneNo = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){5,14}(\s*)?$/i;
  const checkEmail = /.+@.+\..+/i;
  const checkOnlyDigits = /^\d+$/;

  export default {
    name: 'InputField',
    mixins: [fieldProps, checkConditions, combineStyles],
    props: {
      question_sub: {
        type: Number,
        default: null
      },
      view: {
        type: String,
        default: null
      },
      fieldType: {
        type: String,
        default: 'text'
      },
      placeholder: {
        type: String,
        default: null
      },
      text: {
        type: [String, Number],
        default: null
      },
      ico: {
        type: [String, Object],
        default: null
      },
      prepend: {
        type: [String, Object],
        default: null
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      append: {
        type: [String, Object],
        default: null
      },
      event: {
        type: String,
        default: null
      }
    },
    computed: {
      combineStateClasses () {
        return [
          { [this.viewClassName]: this.view },
          { 'has-focus': this.hasFocus },
          { 'has-error': this.hasError },
          { 'is-disabled': this.isDisabled },
          { 'is-qs-hidden': this.hasCondition && !this.checkCondition }
        ]
      },
      viewClassName: function () {
        return `input-field_view-${this.$props.view}`
      },
      isDigitsOnly () {
        return this.$props.output_type && this.$props.output_type === 'num'
      },
      setPrepend () {
        if (this.prepend && this.prepend === 'tel') {
          return () => import(`@/components/UI/PhonePrefixDropdown/TelDropdown.vue`);
        }
        return this.prepend;
      }
    },
    methods: {
      checkNumberInput (e) {
        if (this.isDigitsOnly) {
          let keyCode = (e.keyCode ? e.keyCode : e.which)
          if (keyCode < 48 || keyCode > 57) {
            e.preventDefault()
          }

          const clipboardData = e.clipboardData || window.clipboardData
          if (!clipboardData) {
            return false;
          }
          const pastedData = clipboardData.getData('text')
          if (e.type === 'paste') {
            // все извращения с this.inputVal нужны из-за IE
            if (checkOnlyDigits.test(pastedData)) {
              this.inputVal = '';
              this.inputVal = pastedData;
            } else {
              setTimeout(() => {
                this.inputVal = ''
              }, 0)
            }
          }
        }
      },
      validator () {
        if (!this.$props.required) {
          return true
        }

        let isEmpty = !this.inputVal || !this.inputVal.toString().trim().length

        if (isEmpty) {
          this.$store.commit('polls/updatePollErrorState', isEmpty)
          this.hasError = isEmpty
          return false
        }

        this.hasError = isEmpty

        switch (this.$props.type) {
          case 'email':
            this.hasError = !checkEmail.test(this.inputVal)
            break
          case 'tel':
            this.hasError = !checkPhoneNo.test(this.inputVal)
            break
        }
      },
      changeHandler: function () {
        if (this.hasError || !this.inputVal) {
          return false
        }

        let answer = {
          pollId: this.$props.pollId,
          question: this.$props.question
        };

        let outputType = this.$props.output_type || this.$props.name;
        answer[outputType] = this.$props.output_type === 'num' ? Number(this.inputVal) : this.inputVal;

        if (this.$props.prepend === 'tel') {
          answer[outputType] = this.$store.state.answers.phonePrefix.code + answer[outputType];
        }

        if (this.$props.event) {
          // эта ветка запускается если компонент в составе InputFieldGroup || MultipleInputField
          delete answer.question;
          answer.question_sub = this.$props.question_sub;
          // TODO: необходимо унифицировать обработку в InputFieldGroup и MultipleInputField
          // т.е. всю обрбаотку answer вынести в родительский компонент
          // и убрать этот жуткий пиздец из if else для запуска cb и event
          this.$parent.$emit(this.$props.event, answer);
          this.$emit('cb', this.inputVal);
        } else {
          this.$store.dispatch('answers/addRemoveAnswer', answer);
        }
      },
      stateHandler: function (e) {
        this.hasFocus = e.type === 'focus'

        if (!this.hasFocus) {
          this.validator()
          this.changeHandler()
        }
      }
    },
    data: function () {
      return {
        inputId: `input-${Math.random()}`,
        inputVal: this.$store.state.answers.phonePrefix && this.$props.text && typeof this.$props.text === 'string' ? this.$props.text.replace(this.$store.state.answers.phonePrefix.code, '') : this.$props.text,
        telPrefix: '',
        hasFocus: false,
        hasError: false,
        errorMessage: this.$props.input_type ? this.$props.input_type.error : ''
      }
    }
  }
</script>

<style lang="scss" src="./assets/input-field.scss"></style>
